var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategyGrowth(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 8.75H17C16.5858 8.75 16.25 9.08579 16.25 9.5V21.5C16.25 21.9142 16.5858 22.25 17 22.25H21C21.4142 22.25 21.75 21.9142 21.75 21.5V9.5C21.75 9.08579 21.4142 8.75 21 8.75Z",
    fill: "#523FC0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.75H9C8.58579 12.75 8.25 13.0858 8.25 13.5V21.5C8.25 21.9142 8.58579 22.25 9 22.25H13C13.4142 22.25 13.75 21.9142 13.75 21.5V13.5C13.75 13.0858 13.4142 12.75 13 12.75Z",
    fill: "#523FC0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.75H1C0.585786 14.75 0.25 15.0858 0.25 15.5V21.5C0.25 21.9142 0.585786 22.25 1 22.25H5C5.41421 22.25 5.75 21.9142 5.75 21.5V15.5C5.75 15.0858 5.41421 14.75 5 14.75Z",
    fill: "#523FC0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00018 13.7C1.7634 13.6971 1.53531 13.6103 1.35652 13.4551C1.17774 13.2998 1.05984 13.0861 1.02384 12.8521C0.987831 12.618 1.03605 12.3788 1.1599 12.177C1.28375 11.9752 1.47521 11.8238 1.70018 11.75C4.76721 10.7795 7.71566 9.46798 10.4902 7.83995C13.7064 5.94932 16.6644 3.65021 19.2902 0.999951C19.3828 0.905463 19.4932 0.830293 19.6151 0.778796C19.737 0.7273 19.8679 0.7005 20.0002 0.699951C20.2625 0.701056 20.5139 0.805207 20.7002 0.989951C20.8864 1.17731 20.991 1.43077 20.991 1.69495C20.991 1.95914 20.8864 2.21259 20.7002 2.39995C17.9579 5.17654 14.8652 7.58352 11.5002 9.55995C8.59977 11.2831 5.5134 12.6719 2.30018 13.7C2.20075 13.715 2.09961 13.715 2.00018 13.7Z",
    fill: "#CABCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5C19.7348 6.5 19.4804 6.39464 19.2929 6.20711C19.1054 6.01957 19 5.76522 19 5.5V2.5H16C15.7348 2.5 15.4804 2.39464 15.2929 2.20711C15.1054 2.01957 15 1.76522 15 1.5C15 1.23478 15.1054 0.98043 15.2929 0.792893C15.4804 0.605357 15.7348 0.5 16 0.5H20C20.2652 0.5 20.5196 0.605357 20.7071 0.792893C20.8946 0.98043 21 1.23478 21 1.5V5.5C21 5.76522 20.8946 6.01957 20.7071 6.20711C20.5196 6.39464 20.2652 6.5 20 6.5Z",
    fill: "#CABCFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategyGrowth);
export default __webpack_public_path__ + "static/media/strategy-growth.471b4a984279bef6abddd94a247ffc16.svg";
export { ForwardRef as ReactComponent };